<!--
 * @Author: awu
 * @Date: 2020-11-29 16:14:46
 * @LastEditors: awu
 * @LastEditTime: 2020-12-07 20:59:56
 * @Description: 选择展区
-->
<template>
<div class="basediv">
    <iframe ref="iframe" :src="iframesrc"  style="width:100%;height:100%;border:0;"  @load="iframeLoaded"></iframe>
    <!-- <div class="prevBack" @click="prev('/exhibition')">
        <img :src="require('../../assets/area/prevBack.png')" />
    </div> -->
    <div class="area-home" @click="showExhibitors" >
        <img src="../../assets/allExhi.png" alt="" />
        <span style="margin-left: 8px">{{$t('zhanqu').allExh}}</span>
    </div>
    <!-- 展商搜索 -->
    <el-drawer
        :visible.sync="drawerExhibitor"
        :direction="directionExhibitor"
        :modal="true"
    >   
        <div class="exhibitorDrawer">
            <div class="exhibitorDrawer-search-name">
                <!-- <span>{{$t("header").search_exhibitor}}</span> -->
                <!-- <span style="margin-left: 10px">{{searchExhibitor}}</span> -->
            </div>
            <ul class="el-row exhibitorDrawer-content">
                <li class="el-col el-col-6 exhibitor-item-wrap" v-for="(item, index) in exhibitorData" :key="index">
                    <div class="exhibitor-item" @click="goExhibitorDetail(item.id, item.exhibition_id,item.vhall.id,item)">
                        <div class="exhibitor-img-content" >
                            <img v-if="item.is_store == 0" @click.stop="collectExhibitors(item)" class="new-store" src="~statics/mobileShouye/newUnstore.png">
                            <img v-if="item.is_store == 1" @click.stop="cancelCollectExhibitors(item)" class="new-store" src="~statics/mobileShouye/newStore.png">
                            <img class="exhibitor-img" :src="item.company && item.company.logo_url || logo" />
                        </div>
                        <!-- <div style="width: 100%;height: 130px;background-size: 100%;background-color: #fff;border-radius: 10px 10px 0 0;">
                            <img class="exhibitor-img" :src="item.company && item.company.logo_url || logo" />
                        </div> -->
                        <div class="exhibitor-content">
                            <div class="exhibitor-content-name">
                                <span>{{item.company.name}}</span>
                            </div>
                            <div class="exhibitor-content-place">
                                <span>{{$t("header").place}}:</span>
                                <span>{{ item.company.address}}</span>
                            </div>
                            <div class="exhibitor-content-exhname">
                                <span>{{$t("header").exhibition}}:</span>
                                <span>{{item.vhall.exhibition_name.cn.name}}</span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <div style="margin-top:10px;text-align:center" v-if="totalPage > 1" class="page">
                <Pagination :child-msg="pageparam" @callFather="callFather"></Pagination>
            </div>
        </div>
    </el-drawer>
</div>    
</template>

<script>
import { changeLanuage } from "@/lang";
import CHeader from "../exhibition/components/Headers";
import api from "@/api";
import { mapState } from "vuex";
import { regionDataPlus } from 'element-china-area-data'
import Pagination from '../../components/Pagination'
import qs from 'querystring';

export default {
    data() {
        return {
            logo: require("../../../static/no-logo-new.png"),
            exhibition_id: '',
            status: '',
            drawerExhibitor: false,
            directionExhibitor: 'btt',
            totalPage: 0,
            pageparam: {
                totalNum: 0,
                currentPage: 1,
                size: 15
            },
            province : '',
            city : '',
            area : '',
            options: regionDataPlus,
            selectedOptions: [],
            exhibitorData: [
            ],
            iframesrc: '',
            current_id: '',
            gues_id: ''
        };
    },
    computed: {
        ...mapState(["userInfo","language"]),
    },
    mounted() {
        this.exhibition_id = this.$route.query.exhibition_id
        this.gues_id = localStorage.getItem('GUEST_ID') || ''
        this.sendPageview()
    },
    components: {
        CHeader,
        Pagination
    },
    watch: {
        $route: {
            handler(route) {
                this.exhibition_id = this.$route.query.exhibition_id;
                let route_exhibition_id = route.query.exhibition_id
                if(route_exhibition_id){
                    switch (route.query.exhibition_id) {
                        case '21':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/21-2.5D-new";
                            break;
                        case '23':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/map-cartoon";
                            break;
                        case '25':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/cartoon-new";
                            break;
                        case '31':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/31";
                            break;
                        case '33':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/33-pc-ceshi";
                            break;
                        case '41':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/41-2.5D";
                            break;
                        case '51':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/51";
                            break;
                        case '55':
                            this.iframesrc = "https://720.cloudvhall.com/shidai/55-uzi";
                            break;
                        default:
                            this.iframesrc = `https://720.cloudvhall.com/shidai/${ this.exhibition_id }-pc`;
                            break;
                    }
                    this.iframesrc = `${this.iframesrc}/?t=${(new Date()).valueOf()}`
                }

                if(route_exhibition_id){
                    api.getExhibitor({
                        page: this.pageparam.currentPage,
                        size: 15,
                        exhibition_id: this.exhibition_id
                    }).then((res)=> {
                        if(res.res ==1){
                            this.exhibitorData = res.list
                            this.pageparam.totalNum = res.count;
                            this.totalPage = Math.ceil(res.count /15);
                        }else{
                            this.$message.error(res.mes);
                        }
                    })
                }
                
            },
		    immediate: true,
        },
    },
    methods: {
        sendPageview(){
            this.$http({
                url: `https://gateway.cloudvhall.com:8443/log/api/v1/pageview`,
                method: 'post',
                data: {
                exhibition_id: this.exhibition_id,
                guest_id: this.gues_id
                }
            }).then(res => {
                if(res.res == 1){
                    localStorage.setItem('GUEST_ID',res.guest_id)
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        iframeLoaded(){
            let type = localStorage.getItem("language") || "zh"
            const iframe = this.$refs.iframe;
            iframe.contentWindow.postMessage(type , '*')
        },
        //展商收藏
        collectExhibitors(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else{
                api.isCollectExhibitors({
                    exhibition_id: item.exhibition_id,
                    company_id:  item.company.id 
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 1;
                        this.$message({
                            type: 'success',
                            message: '收藏成功'
                        })
                        // this.$notify({ type: 'success', message: '收藏成功' });
                    }
                });
            }
        },
        cancelCollectExhibitors(item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else{
                api.noCollectExhibitors({
                    exhibition_id: item.exhibition_id,
                    company_id:  item.company.id
                }).then((res) => {
                    console.log(res);
                    if (res.res == 1) {
                        item.is_store = 0;
                        this.$message({
                            type: 'success',
                            message: '取消收藏'
                        })
                        // this.$notify("取消收藏");
                    }
                });
            }
        },
        handleExhibitorsStore(_item) {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else {
                // console.log(_item)
                if(!_item.is_store) {
                    this.exhibitorsStore(_item);
                }else {
                    this.exhibitorsCancelStore(_item)
                }
            }
        },
        handleLangExhibitorsStore(_item) {
            if(_item.is_store) {
                if(this.language == 'zh') {
                    return '已收藏'
                }else {
                    return 'Stored'
                }
            }else {
                if(this.language == 'zh') {
                    return '收藏'
                }else {
                    return 'Store'
                }
            }
        },
        exhibitorsStore(_item) {
            api.isCollectExhibitors({
                exhibition_id: _item.exhibition_id,
                company_id: _item.company.id
            }).then((res) => {
                // console.log(res);
                if (res.res == 1) {
                    this.$message.success("收藏成功");
                    _item.is_store = 1;
                }
            });
        },
        exhibitorsCancelStore(_item) {
            api.noCollectExhibitors({
                exhibition_id: _item.exhibition_id,
                company_id: _item.company.id
            }).then((res) => {
                // console.log(res);
                if (res.res == 1) {
                    this.$message.success("取消收藏");
                    _item.is_store = 0;
                }
            });
        },
        prev(path) {
          this.$router.push(path);
        },
        goExhibitorDetail(_id,_exhibition_id,_vhall_id,item){
            if(_exhibition_id == 79) {
                item.vhall && item.vhall.url && window.open(item.vhall.url)
            }else {
                 this.$router.push({
                    path: '/area/ztDetail',
                    query:{
                        company_id: _id,
                        exhibition_id: _exhibition_id,
                        instance_id: _vhall_id
                    }
                })
            }
        },
        callFather(param) {
            this.pageparam.currentPage = param.currentPage;
            this.handleGetExhibitor()
        },
        showExhibitors(){
            this.handleGetExhibitor()
            this.drawerExhibitor = true
        },
        handleGetExhibitor(){
            api.getExhibitor({
                // search: this.searchExhibitor,
                page: this.pageparam.currentPage,
                size: this.pageparam.size || 10,
                exhibition_id: this.exhibition_id
            }).then((res)=> {
                if(res.res ==1){
                    // if(this.valuePavilion == '100'){
                    //     this.drawerExhibitor = true
                    //     this.drawerGoods = false
                    // }
                    this.drawerExhibitor = true
                    this.exhibitorData = res.list
                    this.pageparam.totalNum = res.count;
                    this.totalPage = Math.ceil(res.count / (this.pageparam.size || 10));
                }else{
                    this.$message.error(res.mes);
                }
            })
        },
        handleChange (value) {
            console.log(value)
            this.province = value[0]
            this.city = value[1]
            this.area = value[2]
        },
        goPath(event, item) {
            if (event.target.tagName.toUpperCase() !== "DIV") {
                return;
            }
            if (item.areaDate) {
                this.$router.push({
                    path: "/area/zhantai",
                    query: {
                        areaDate: item.areaDate,
                        exhibition_id: this.exhibition_id
                    }
                });
            } else {
                this.$message.error("暂无展台数据");
            }
        },
        hideImg(item) {
            setTimeout(() => {
                item.imgShow = false;
            }, 100);
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .el-input{
    height: 20px;
}
/deep/ .el-select .el-input .el-select__caret{
    font-size: 20px;
    color: #778DB3;
}
/deep/ .el-input__inner{
    background: unset;
    border: unset;
    height: 20px;
    font-size: 18px;
    color: #49546B
}
/deep/ .el-input__icon{
    line-height: 20px;
    font-size: 20px;
}
/deep/ .el-drawer__header{
    display: none;
    
}
/deep/ .el-tabs__header{
    margin: 30px 390px 20px 250px
}
/deep/ .el-tabs__content{
    margin: 30px 250px 20px 250px
}
/deep/ .el-drawer{
    height: 90% !important;
    box-shadow: 0px -10px 30px 0px rgba(6, 58, 120, 0.5);
}
/deep/ .el-tabs__item{
    font-size: 18px;
}
/deep/ .el-tabs__nav-wrap::after{
    width: unset;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
    background: #194B96;
}
.basediv {
    width: 100%;
    height: 100%;
    background-size: 100% 100%;
    position: relative;
}
.page {
    margin-top: 10px;
    text-align: center;
}
.zhanqu {
    width: 100%;
    height: 100%;
    background: url("../../assets/area/areaBc.png");
    background-size: 100% 100%;
    position: relative;
    .box1 {
        width: 6%;
        height: 15%;
        position: absolute;
        left: 35.25%;
        top: 50.41%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -80px;
            right: -200px;
        }
    }
    .box2 {
        width: 12%;
        height: 12%;
        position: absolute;
        left: 48.35%;
        top: 61.85%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -260px;
        }
    }
    .box3 {
        width: 9%;
        height: 12%;
        position: absolute;
        left: 41.46%;
        top: 50.84%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -280px;
        }
    }
    .box4 {
        width: 7%;
        height: 24%;
        position: absolute;
        left: 69.63%;
        top: 37.31%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -200px;
        }
    }
    .box5 {
        width: 9%;
        height: 24%;
        position: absolute;
        left: 45.15%;
        top: 30.09%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -300px;
        }
    }
}
.zhanqu_trade {
    width: 100%;
    height: 100%;
    background: url("../../assets/area/areaTrade.png");
    background-size: 100% 100%;
    position: relative;
    .box1 {
        width: 7%;
        height: 15%;
        position: absolute;
        left: 31.97%;
        top: 47.96%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -80px;
            right: 50px;
        }
    }
    .box2 {
        width: 10%;
        height: 20%;
        position: absolute;
        left: 37.9%;
        top: 38.44%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -50px;
        }
    }
    .box3 {
        width: 10%;
        height: 20%;
        position: absolute;
        left: 47.9%;
        top: 36.44%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -100px;
            right: -50px;
        }
    }
    .box4 {
        width: 10%;
        height: 20%;
        position: absolute;
        left: 70.73%;
        top: 44.11%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -100px;
            right: -100px;
        }
    }
    .box5 {
        width: 15%;
        height: 20%;
        position: absolute;
        left: 58.22%;
        top: 41.85%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -50px;
        }
    }
    .box6 {
        width: 15%;
        height: 15%;
        position: absolute;
        left: 46.63%;
        top: 59.12%;
        cursor: pointer;
        > img {
            position: absolute;
            top: -50px;
            right: -50px;
        }
    }
}
.area-home {
    width: 170px;
    height: 60px;
    background: #FFFFFF;
    box-shadow: 5px 5px 20px 0px rgba(6, 58, 120, 0.5);
    border-radius: 30px;
    position: absolute;
    z-index: 5;
    bottom: 20px;
    left: 37px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.prevBack {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 37px;
      top: 250px;
      z-index: 100;
      width: 58px;
      height: 58px;
      background: #ffffff;
      border-radius: 50%;
    }
.exhibitorDrawer{
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - 100px);
        /*定义滚动条高宽及背景*/
        &::-webkit-scrollbar {
            width: 1px;
        }
        /*定义滚动条*/
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px #fff;
            background: #fff;
        }
        /*定义滚动条轨道*/
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px #fff;
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
        }
        margin: 0 240px;
        padding-top: 30px;
        .exhibitorDrawer-search-name{
            height: 22px;
            font-size: 16px;
            font-weight: 400;
            color: #49546B;
            line-height: 22px;
        }
        .exhibitorDrawer-content {
          flex: 1;
          overflow: scroll;
        }
        .exhibitorDrawer-search-place{
            display: flex;
            align-items: center;
            margin: 30px 0 25px 0;
            .pick-place{
                // width: 80px;
                height: 22px;
                font-size: 16px;
                font-weight: 400;
                color: #49546B;
                line-height: 22px;
            }
            .pick-button{
                width: 382px;
                height: 44px;
                background: #FFFFFF;
                border-radius: 22px;
                border: 1px solid #194B96;
            }
        }
        .exhibitor-item-wrap{
            cursor: pointer;
            width: 19%;
            height: 210px;
            background: #F2F7FF;
            border-radius: 10px;
            border: 1px solid #C9C9D8;
            box-sizing: border-box;
            margin: 0px 10px 20px 0px;
            .exhibitor-item{
                 .exhibitor-img-content{
                    width: 100%;
                    height: 130px;
                    background-size: 100%;
                    background-color: #fff;
                    border-radius: 10px 10px 0 0;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // padding: 8px 0px;
                    // margin: 10px 0px;
                    .new-store{
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 28px;
                        height: 28px;
                    }
                    .exhibitor-img{
                        max-width: 100%;
                        max-height: 130px;
                        object-fit: contain;
                        // border-radius: 10px 10px 0 0;
                        padding: 10px;
                    }
                    .company-view-item{
                        position: absolute;
                        top: 5px;
                        left: 1px;
                        // background: red;
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                        // display: flex;
                        // align-items: center;
                        font-size: 14px;
                        
                        .icon-store{
                            font-size: 19px;
                            box-shadow: 2px #194B96;
                            &:hover{
                                color: #194B96;
                             }
                        }
                        .unactive{
                            color: #8d8d8d;
                        }
                        .active{
                            color: #194B96;
                        }
                    }
                }
                // .exhibitor-img{
                //     width: 100%;
                //     height: 130px;
                //     object-fit: contain;

                //     border-radius: 10px 10px 0 0;
                // }
                .exhibitor-content{
                    height: 80px;
                    margin-left: 16px;
                    margin-right: 10px;
                    .exhibitor-content-name{
                        font-size: 16px;
                        font-weight: 500;
                        color: #333333;
                        height: 22px;
                        line-height: 22px;
                        margin: 8px 0 3px 0;
                        // width: 230px;
                        overflow:hidden;
				        white-space: nowrap;
				        text-overflow: ellipsis;
                    }
                    .exhibitor-content-place{
                        height: 17px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        margin-bottom: 3px;
                        // width: 230px;
                        overflow:hidden;
				        white-space: nowrap;
				        text-overflow: ellipsis;
                    }
                    .exhibitor-content-exhname{
                        height: 17px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #666666;
                        line-height: 17px;
                        // width: 210px;
                        overflow: hidden;
                        text-overflow:ellipsis; 
                        white-space: nowrap;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/area/zhanqu.vue